import axios from "axios";
import { URLAPI, URL_MIDIS } from "../../Setting";
import { Magasin, TypeMagasin } from "../../Models/Magasin/MagasinModels";
import { errorService } from "../Error/ErrorService";
import { EmailService } from "../Email/EmailService";
import { ClientService } from "../Client/ClientService";
import { TypeMagasinService } from "./TypeMagasinService";
import { SousGroupeService } from "./SousGroupeService";
import { Client } from "../../Models/Client/ClientModels";
import { OptionsPackService } from "../Abonnement/OptionsPackService";
import { OptionsAbonnementService } from "../Abonnement/OptionsAbonnementService";
import { Flux } from "../../Models/Message/MessageModels";
import { FluxService } from "../Message/FluxService";

export function MagasinService(){
  return{
    async getMagasin(id: number, token:any) : Promise<Magasin>{
      //services
      try {
        const response = await axios.get(`${URLAPI}magasin/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type":"application/ld+json"
          },
        })
  
        const data = response.data['hydra:member']
      //   return response.data['hydra:member'][0]
        let magasin : Magasin = {
          id: data[0]['id'],
          nom: data[0]['nom'],
          raison_sociale:data[0]['raison_sociale'],
          typeMagasin: data[0]['typeMagasin'],
          emails: data[0]['emails'],
          sousGroupes: data[0]['sousGroupes'],
          edited: false,
          actif:true,
          abonnements:[]
        }
        return magasin;
      } catch (error) {
        errorService().handleError('Erreur lors du getMagasin', error)
        let magasin : Magasin = {
          id: 0,
          nom: "",
          raison_sociale:'',
          client: undefined,//temporaire
          abonnements:[],
          typeMagasin: undefined,
          emails: [],
          sousGroupes: [],
          edited: false,
          actif:false,
        }
        return magasin;
      }
    },
  
    //Tous les magasins disponibles
    async getMagasinsUtilisateur(token:any): Promise<Magasin[]>{
      try {
        const response = await axios.get(`${URLAPI+'magasins'}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type":"application/ld+json"
          },
        });
        const data = response.data['hydra:member'];
        let magasins:Magasin[] = [];

        for(const magasin of data){
          magasins.push({
            id: magasin['id'],
            '@id':magasin['@id'],
            nom: magasin['nom'],
            raison_sociale:magasin['raison_sociale'],
            abonnements: magasin['abonnements'],
            typeMagasin: magasin['typeMagasin'],
            emails: magasin['emails'],
            sousGroupes: magasin['sousGroupes'],
            edited: false,
          });
        }

        return magasins;
      } catch (error) {
        errorService().handleError('Erreur obtention magasins utilisateurs', error)
        return [];
      }
    },

    //Tous les magasins disponibles pour administration
    async getMagasinsUtilisateruWithAllDatas(token:string){
      try {
        const response = await axios.get(`${URLAPI+'magasins'}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type":"application/ld+json"
          },
        });
        const data = response.data['hydra:member'];
        let magasins:Magasin[] = [];

        // let fluxes:Flux[] = await FluxService().getFluxesLight(token);
        let typesMagasins:TypeMagasin[] = await TypeMagasinService().getTypesMagasins(token);

        for(const magasin of data){
          magasins.push({
            id: magasin['id'],
            '@id':magasin['@id'],
            clientUrl:magasin['client'],
            nom: magasin['nom'],
            raison_sociale:magasin['raison_sociale'],
            abonnements: magasin['abonnements'].map((abo:any, index:any)=>{
              return { //gestion de l'abonnement en objet pour gérer les appels API pour optionsPack dans Pack de l'abonnement
                id:magasin['abonnements'][index]['id'],
                '@id':magasin['abonnements'][index]['@id'],
                actif:true,
                fluxes:magasin['abonnements'][index]['fluxes'],
                nom:magasin['abonnements'][index]['nom'],
                souscription:new Date(magasin['abonnements'][index]['souscription']),
                optionsAbonnement:magasin['abonnements'][index]['optionsAbonnement'].map((options:any)=>{return {'@id':options, id:0, nom:'', quota:0, utilise:0}}),
                pack:{
                  id:magasin['abonnements'][index]['pack']['id'],
                  nbFlux:magasin['abonnements'][index]['pack']['nbFlux'],
                  nom:magasin['abonnements'][index]['pack']['nom'],
                  achatCarnet:magasin['abonnements'][index]['pack']['achatCarnet'],
                  metier:magasin['abonnements'][index]['pack']['metier'],
                  optionsPack:magasin['abonnements'][index]['pack']['optionsPack'].map((options:any)=>{return {'@id':options, id:0, nom:'', valeur:false}}) //mise sous forme d'obj tout en recupérant url api
                },
                exceptionsMusique:magasin['abonnements'][index]['exceptionsMusique']
              }
            }),
            typeMagasin: typesMagasins.find(type=>type.id===magasin['typeMagasin']['id']) ?? magasin['typeMagasin'],
            emails: magasin['emails'],
            sousGroupes: magasin['sousGroupes'],
            edited: false,
            actif:true,
          });
        }

        const optionsPack = await OptionsPackService().getOptionsPack(token);
        const optionsAbonnement = await OptionsAbonnementService().getOptionsAbonnement(token);
        //mise en place des obj client & optionsPack dans obj magasins via l'entière liste des clients
        for(let indexMag=0;indexMag<magasins.length;indexMag++){

          //gestion optionsAbonnements dans Abonnements Magasins
          const initialAbos = magasins[indexMag].abonnements;
          
          if(initialAbos) {
            for(let indexAbo=0;indexAbo<initialAbos.length;indexAbo++){
              initialAbos[indexAbo].optionsAbonnement = initialAbos[indexAbo].optionsAbonnement?.map(option=>{
                let result:any;
                for(let indexOptAbo=0;indexOptAbo<optionsAbonnement.length;indexOptAbo++){
                  if(option['@id']===optionsAbonnement[indexOptAbo]['@id']){
                    result = {...option,
                      id:optionsAbonnement[indexOptAbo]['id'],
                      nom:optionsAbonnement[indexOptAbo]['nom'],
                      quota:optionsAbonnement[indexOptAbo]['quota'],
                      utilise:optionsAbonnement[indexOptAbo]['utilise'],
                      typesMessage:optionsAbonnement[indexOptAbo]['typesMessage'],
                      '@id':optionsAbonnement[indexOptAbo]['@id']
                    }
                  }
                }
                return result
              });

              //gestion optionsPacks pour packs Abonnements Magasins
              const initialPack = initialAbos[indexAbo].pack;
        
              if(initialPack) initialPack.optionsPack = initialAbos[indexAbo].pack?.optionsPack?.map(option=>{
                let result:any
                for(let indexOptPack=0;indexOptPack<optionsPack.length;indexOptPack++){
                  if(option['@id']===optionsPack[indexOptPack]['@id']){
                    result = {...option,
                      id:optionsPack[indexOptPack].id,
                      nom:optionsPack[indexOptPack].nom,
                      valeur:optionsPack[indexOptPack].valeur,
                      typeMessage:optionsPack[indexOptPack].typeMessage,
                      "@id":optionsPack[indexOptPack]['@id']
                    };
                    break;
                  }
                }
                return result;
              });

            }
          }
        }
        return magasins;
      } catch (error) {
        errorService().handleError('Erreur lors du getMagasinsForAdmin', error);
        return [];
      }
    },

    //Tous les magasins disponibles pour administration
    async getMagasinsForAdmin(clients:Client[], token:string){
      try {
        const response = await axios.get(`${URLAPI+'magasins'}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type":"application/ld+json"
          },
        });
        const data = response.data['hydra:member'];
        let magasins:Magasin[] = [];

        for(const magasin of data){
          magasins.push({
            id: magasin['id'],
            // '@id':magasin['@id'],
            clientUrl:magasin['client'],
            nom: magasin['nom'],
            raison_sociale:magasin['raison_sociale'],
            abonnements: magasin['abonnements'].map((_:any, index:any)=>{
              return { //gestion de l'abonnement en objet pour gérer les appels API pour optionsPack dans Pack de l'abonnement
                id:magasin['abonnements'][index]['id'],
                actif:true,
                fluxes:magasin['abonnements'][index]['fluxes'],
                nom:magasin['abonnements'][index]['nom'],
                souscription:new Date(magasin['abonnements'][index]['souscription']),
                optionsAbonnement:magasin['abonnements'][index]['optionsAbonnement'].map((options:any)=>{return {'@id':options, id:0, nom:'', quota:0, utilise:0}}),
                pack:{
                  id:magasin['abonnements'][index]['pack']['id'],
                  nbFlux:magasin['abonnements'][index]['pack']['nbFlux'],
                  nom:magasin['abonnements'][index]['pack']['nom'],
                  achatCarnet:magasin['abonnements'][index]['pack']['achatCarnet'],
                  metier:magasin['abonnements'][index]['pack']['metier'],
                  optionsPack:magasin['abonnements'][index]['pack']['optionsPack'].map((options:any)=>{return {'@id':options, id:0, nom:'', valeur:false}}) //mise sous forme d'obj tout en recupérant url api
                },
                exceptionsMusique:magasin['abonnements'][index]['exceptionsMusique']
              }
            }),
            typeMagasin: magasin['typeMagasin'],
            emails: magasin['emails'],
            sousGroupes: magasin['sousGroupes'],
            edited: false,
            actif:true,
          });
        }

        const optionsPack = await OptionsPackService().getOptionsPack(token);
        const optionsAbonnement = await OptionsAbonnementService().getOptionsAbonnement(token);
        //mise en place des obj client & optionsPack dans obj magasins via l'entière liste des clients
        for(let indexMag=0;indexMag<magasins.length;indexMag++){

          //gestion optionsAbonnements dans Abonnements Magasins
          const initialAbos = magasins[indexMag].abonnements;
          
          if(initialAbos) {
            for(let indexAbo=0;indexAbo<initialAbos.length;indexAbo++){
              initialAbos[indexAbo].optionsAbonnement = initialAbos[indexAbo].optionsAbonnement?.map(option=>{
                let result:any;
                for(let indexOptAbo=0;indexOptAbo<optionsAbonnement.length;indexOptAbo++){
                  if(option['@id']===optionsAbonnement[indexOptAbo]['@id']){
                    result = {...option,
                      id:optionsAbonnement[indexOptAbo]['id'],
                      nom:optionsAbonnement[indexOptAbo]['nom'],
                      quota:optionsAbonnement[indexOptAbo]['quota'],
                      quotaRenouvele:optionsAbonnement[indexOptAbo]['quotaRenouvele'],
                      utilise:optionsAbonnement[indexOptAbo]['utilise'],
                      typesMessage:optionsAbonnement[indexOptAbo]['typesMessage'],
                      '@id':optionsAbonnement[indexOptAbo]['@id']
                    }
                  }
                }
                return result
              });

              //gestion optionsPacks pour packs Abonnements Magasins
              const initialPack = initialAbos[indexAbo].pack;
        
              if(initialPack) initialPack.optionsPack = initialAbos[indexAbo].pack?.optionsPack?.map(option=>{
                let result:any
                for(let indexOptPack=0;indexOptPack<optionsPack.length;indexOptPack++){
                  if(option['@id']===optionsPack[indexOptPack]['@id']){
                    result = {...option,
                      id:optionsPack[indexOptPack].id,
                      nom:optionsPack[indexOptPack].nom,
                      valeur:optionsPack[indexOptPack].valeur,
                      typeMessage:optionsPack[indexOptPack]['typeMessage'],
                      "@id":optionsPack[indexOptPack]['@id']
                    };
                    break;
                  }
                }
                return result;
              });

            }
          }

          //gestion client des magasins
          for(let indexClient=0;indexClient<clients.length;indexClient++){
            if(magasins[indexMag].clientUrl === clients[indexClient]['@id']){
              magasins[indexMag] = {...magasins[indexMag], client:clients[indexClient],};
            }
          }
        }
        return {data:magasins, status:response.status};
      } catch (error) {
        errorService().handleError('Erreur lors du getMagasinsForAdmin', error);
        return {data:[], status:400};
      }
    },

    //Tous les magasins disponibles avec données épurées pour optimiser chargement + pas enregistrer données non nécessaire
    async getMagasinsForAdressesContact(token:any): Promise<Magasin[]>{
      try {
        const response = await axios.get(`${URLAPI+'magasins'}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type":"application/ld+json"
          },
        });
        const data = response.data['hydra:member'];
        let magasins:Magasin[] = [];

        for(const magasin of data){
          magasins.push({
            id: magasin['id'],
            nom: magasin['nom'],
            raison_sociale:magasin['raison_sociale'],
            emails: magasin['emails'],
            edited: false,
            actif:true,
            sousGroupes:magasin['sousGroupes'],
            abonnements:[]
          });
        }
        return magasins;
      } catch (error) {
        return [];
      }
    },

    //Tous les magasins d'un client pour observer ses abonnements
    async getMagasinsForVosAbonnements(token:string){
      try {
        const response = await axios.get(`${URLAPI+'magasins'}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type":"application/ld+json"
          },
        });
        const data = response.data['hydra:member'];
        let magasins:Magasin[] = []
        let client:Client = await ClientService().getClientForMonCompte(token);
        for(const element of data){
          // Appeler les services et attendre les résultats
          // const [client] = await Promise.all([
          //   ClientService().getClientFromUrlWithoutForeignKeysData(element['client'],token),
          // ]);
          // clients.push(client);

          magasins.push({
            id: element['id'],
            client:client,
            // client:element['client'],
            nom: element['nom'],
            raison_sociale:element['raison_sociale'],
            abonnements: element['abonnements'].map((_:any, index:any)=>{
              return { //gestion de l'abonnement en objet pour gérer les appels API pour optionsPack dans Pack de l'abonnement
                id:element['abonnements'][index]['id'],
                actif:true,
                fluxes:element['abonnements'][index]['fluxes'],
                nom:element['abonnements'][index]['nom'],
                souscription:new Date(element['abonnements'][index]['souscription']),
                optionsAbonnement:element['abonnements'][index]['optionsAbonnement'].map((options:any)=>{return {'@id':options, id:0, nom:'', quota:0, utilise:0}}),
                pack:{
                  id:element['abonnements'][index]['pack']['id'],
                  nbFlux:element['abonnements'][index]['pack']['nbFlux'],
                  nom:element['abonnements'][index]['pack']['nom'],
                  achatCarnet:element['abonnements'][index]['pack']['achatCarnet'],
                  metier:element['abonnements'][index]['pack']['metier'],
                  optionsPack:element['abonnements'][index]['pack']['optionsPack'].map((options:any)=>{return {'@id':options, id:0, nom:'', valeur:false}}) //mise sous forme d'obj tout en recupérant url api
                },
                exceptionsMusique:element['abonnements'][index]['exceptionsMusique']
              }
            }),
            typeMagasin: element['typeMagasin'],
            emails: element['emails'],
            sousGroupes: element['sousGroupes'],
          });
        }

        const optionsPack = await OptionsPackService().getOptionsPack(token);
        const optionsAbonnement = await OptionsAbonnementService().getOptionsAbonnement(token);
        //mise en place des obj client & optionsPack dans obj magasins via l'entière liste des clients
        for(let indexMag=0;indexMag<magasins.length;indexMag++){

          //gestion optionsAbonnements dans Abonnements Magasins
          const initialAbos = magasins[indexMag].abonnements;
          
          if(initialAbos) {
            for(let indexAbo=0;indexAbo<initialAbos.length;indexAbo++){
              initialAbos[indexAbo].optionsAbonnement = initialAbos[indexAbo].optionsAbonnement?.map(option=>{
                let result:any;
                for(let indexOptAbo=0;indexOptAbo<optionsAbonnement.length;indexOptAbo++){
                  if(option['@id']===optionsAbonnement[indexOptAbo]['@id']){
                    result = {...option,
                      id:optionsAbonnement[indexOptAbo]['id'],
                      nom:optionsAbonnement[indexOptAbo]['nom'],
                      quota:optionsAbonnement[indexOptAbo]['quota'],
                      utilise:optionsAbonnement[indexOptAbo]['utilise'],
                      typesMessage:optionsAbonnement[indexOptAbo]['typesMessage'],
                      '@id':optionsAbonnement[indexOptAbo]['@id']
                    }
                  }
                }
                return result
              });

              //gestion optionsPacks pour packs Abonnements Magasins
              const initialPack = initialAbos[indexAbo].pack;
        
              if(initialPack) initialPack.optionsPack = initialAbos[indexAbo].pack?.optionsPack?.map(option=>{
                let result:any
                for(let indexOptPack=0;indexOptPack<optionsPack.length;indexOptPack++){
                  if(option['@id']===optionsPack[indexOptPack]['@id']){
                    result = {...option,
                      id:optionsPack[indexOptPack].id,
                      nom:optionsPack[indexOptPack].nom,
                      valeur:optionsPack[indexOptPack].valeur,
                      "@id":optionsPack[indexOptPack]['@id']
                    };
                    break;
                  }
                }
                return result;
              });

            }
          }

          //gestion client des magasins
          // for(let indexClient=0;indexClient<clients.length;indexClient++){
          //   if(magasins[indexMag].clientUrl === clients[indexClient]['@id']){
          //     magasins[indexMag] = {...magasins[indexMag], client:clients[indexClient],};
          //   }
          // }
        }

        return {
          data:magasins, status:response.status
        };
      } catch (error) {
        errorService().handleError('Erreur lors du getMagasinsForVosAbonnements', error)
        return;
      }
    },
  
    //Création du tableau de magasins suite aux données obtenues dans l'api
    async getMagasinsFromUrlToClient(urls:string[],token:string):Promise<Magasin[]>{
      let magasins:Magasin[]=[];
      for(const url of urls){
        try {
          const response = await axios.get(`${URL_MIDIS+url}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type":"application/ld+json"  
            },
          });
          const data = response.data['hydra:member'];
          for(const element of data){
            const [sousGroupes] = await Promise.all([
              SousGroupeService().getSousGroupesFromUrlsToPromiseToMagasin(element['sousGroupes'], token)
            ]);

            magasins.push({
              id: element['id'],
              nom: element['nom'],
              raison_sociale:element['raison_sociale'],
              abonnements: element['abonnements'],
              typeMagasin: element['typeMagasin'],
              emails: element['emails'],
              sousGroupes: sousGroupes,
              edited: false,
              actif:true,
            });
          }
        } catch (error) {
            errorService().handleError('Erreur lors du getMagasinsFromUrlToClient', error)
            return []
        }
      }
     
      return magasins;
    },

    /**
     * Création du tableau de magasins pou le client dans l'administration
     * Toutes les données ne sont pas enregistrés pour des question de non-utilisation & d'optimisation
     * @param urls 
     * @param token 
     * @returns Promise de tableau de Magasin
     */
    async getMagasinsFromUrlsToAnythingWithoutForeignKeysData(urls:string[],token:string):Promise<Magasin[]>{
      const controller = new AbortController();
      let magasins:Magasin[]=[];
      if(urls.length>0){
        for(const url of urls){
          try {
            const response = await axios.get(`${URL_MIDIS+url}`, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type":"application/ld+json"  
              },
              signal:controller.signal
            });
            const data = response.data['hydra:member'];
            magasins=[...magasins, {
              id: data[0]['id'],
              nom: data[0]['nom'],
              raison_sociale:data[0]['raison_sociale'],
              edited: false,
              actif:true,
              sousGroupes:data[0]['sousGroupes'],
              abonnements:[]
            }];
          } catch (error) {
              controller.abort();
              errorService().handleError('Erreur lors du getMagasinsFromUrlToAnythingWithoutForeignKeysData', error)
              return []
          }
        }
      }
      controller.abort();
      return magasins;
    },
  
    /**
     * Cette méthode permet de transformer un magasin, rataché à un client, via une URL, en un objet Magasin.
     * Pour éviter toute boucle infini via la relation entre un client et son/ses magasin(s),
     * il est préférable de ne pas enregistré la valeur lié à client, ni de la transformer en objet Client. 
     * Donc celle-ci restera un objet Client|undefined, qui ici sera undefined. (Modification possible à l'avenir).
     * 
     * Si vous souhaitez accèder au client à partir de l'objet magasin, alors employez la méthode ??? (p-e getClientFromUrlForMagasin)
     */
    async getMagasinFromUrlToPromiseToAnything(url:string, token:string):Promise<Magasin>{
      let magasin : Magasin = {
        id: 0,
        nom: "",
        raison_sociale:'',
        abonnements: [],
        typeMagasin: undefined,
        emails: [],
        sousGroupes: [],
      };
      try {
        const response = await axios.get(`${URL_MIDIS+url}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type":"application/ld+json"
          },
        });
        let data = response.data['hydra:member'];
        
        if(data.length>0){
          magasin = {
            id: data[0]['id'],
            nom: data[0]['nom'],
            raison_sociale:data[0]['raison_sociale'],
            abonnements: data[0]['abonnements'],
            typeMagasin: data[0]['typeMagasin'],
            emails: data[0]['emails'],
            sousGroupes: data[0]['sousGroupes'],
          }
        }
       
      } catch (error) {
        errorService().handleError('Erreur lors du getMagasinFromUrlToPromiseToClient', error);
      }
      return magasin
    },

    /**
     * Cette méthode permet de transformer un magasin, rataché à un client, via une URL, en un objet Magasin.
     * Pour éviter toute boucle infini via la relation entre un client et son/ses magasin(s),
     * il est préférable de ne pas enregistré la valeur lié à client, ni de la transformer en objet Client. 
     * Donc celle-ci restera un objet Client|undefined, qui ici sera undefined. (Modification possible à l'avenir).
     * 
     * Si vous souhaitez accèder au client à partir de l'objet magasin, alors employez la méthode ??? (p-e getClientFromUrlForMagasin)
     */
    async getMagasinsFromUrlToPromiseToTypeMagasinToEnseigne(urls:string, token:string):Promise<Magasin[]>{ //à finir si besoin
      let magasins:Magasin[]=[]
      for(const url of urls){
        try {
          const response = await axios.get(`${URL_MIDIS+url}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type":"application/ld+json"
            },
          });
          const data = response.data['hydra:member'];
          if(data.length>0){

            const [typeMagasin, emails] = await Promise.all([
              // AbonnementService().getAbonnementFromUrlToPromiseToMagasin(data[0]['abonnements'], token),
              TypeMagasinService().getTypeMagasinFromUrlToPromiseToMagasin(data[0]['typeMagasin'], token),
              EmailService().getEmailsFromUrlsToMagasin(data[0]['emails'], token)
            ]);

            magasins.push({
              id: data[0]['id'],
              nom: data[0]['nom'],
              raison_sociale:data[0]['raison_sociale'],
              client:undefined,
              abonnements: data[0]['abonnements'],
              typeMagasin: typeMagasin,
              emails: emails,
              sousGroupes: data[0]['sousGroupes'],//temporaire
              edited: false,
              actif:true,
            })
          }
        } catch (error) {
          errorService().handleError('Erreur lors du getMagasin', error)
          return [];
        }
      }
      return magasins;
    },

    async deleteMagasin(idMagasin:number, idIdentifiant:number|undefined, token:any){
      if(!idIdentifiant){
        const responseMagasin = await axios.delete(
          `${URLAPI}magasin/${idMagasin}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        return responseMagasin.status;
      }
      //On s'assure de la suppression de l'idntifiant lié au magasin avant de supprimer le magasin
      // const responseIdentifiant = await axios.delete(
      //   `${URLAPI}identifiant/${idIdentifiant}`,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //     },
      //   }
      // );
      // if(responseIdentifiant.status===200||responseIdentifiant.status===201){
        const responseMagasin = await axios.delete(
          `${URLAPI}magasin/${idMagasin}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        return responseMagasin.status;
      // }
      // return responseIdentifiant.status;
    }
  }

}